import _export from '../internals/export.js';
import numberParseFloat from '../internals/number-parse-float.js';

var $ = _export;
var parseFloat = numberParseFloat; // `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing

$({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat != parseFloat
}, {
  parseFloat: parseFloat
});
